import script from "./DataProtection.vue?vue&type=script&setup=true&lang=js"
export * from "./DataProtection.vue?vue&type=script&setup=true&lang=js"

import "./DataProtection.vue?vue&type=style&index=0&id=494b197a&lang=css"

const __exports__ = script;

export default __exports__